import { render, staticRenderFns } from "./ProfileCompany.partials.vue?vue&type=template&id=555ef2d3&"
import script from "./ProfileCompany.partials.vue?vue&type=script&lang=js&"
export * from "./ProfileCompany.partials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports